<!--
A lightweight component that switches between the two discharge menus
based on the version of the plan.

Once V! plans are removed this will no longer be necessary.
-->
<script setup lang="ts">
import { PlanSchemaVersion } from "@/api/dischargePlan/types";
import { useDischargePlanStore } from "@/stores/dischargePlan";
import { storeToRefs } from "pinia";
import DischargeMenuV1 from "./Legacy/DischargeMenuV1.vue";
import DischargeMenuV2 from "./DischargeMenuV2.vue";

const dischargePlanStore = useDischargePlanStore();

const { activePlan } = storeToRefs(dischargePlanStore);
</script>
<template>
  <template v-if="activePlan?.schemaVersion == PlanSchemaVersion.Initial">
    <DischargeMenuV1 />
  </template>
  <template
    v-if="activePlan?.schemaVersion == PlanSchemaVersion.PostProductQuality"
  >
    <DischargeMenuV2 />
  </template>
</template>
